// https://swiperjs.com/get-started
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

// eslint-disable-next-line no-unused-vars
const swiper = new Swiper('.swiper-cover', {
  modules: [Navigation, Pagination],

  // effect: 'coverflow',
  autoplay: true,
  loop: true,
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 12,
  grabCursor: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 1.125,
      spaceBetween: 20
    },
    1280: {
      slidesPerView: 1.25,
      spaceBetween: 30
    },
    1560: {
      slidesPerView: 2,
      spaceBetween: 30
    }
  }
})

// eslint-disable-next-line no-unused-vars
const swiperNewPost = new Swiper('.swiper-4', {
  modules: [Navigation, Pagination],

  autoplay: false,
  loop: false,
  freeMode: true,
  slidesPerView: 1.125,
  centeredSlides: true,
  spaceBetween: 12,
  grabCursor: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 16
    },
    980: {
      slidesPerView: 3,
      spaceBetween: 24,
      centeredSlides: false
    },

    1280: {
      slidesPerView: 4,
      spaceBetween: 30,
      centeredSlides: false
    }
  }
})
